import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import './style.scss';

interface LeaderboardCardSimpleProps {
  onBlur: Function;
}
const LeaderboardCardSimple: React.FC<LeaderboardCardSimpleProps> = ({ ...props }) => {
  const [userPoints, setUserPoints] = useState('0');
  const [userPlace, setUserPlace] = useState('No');

  useEffect(() => {
    const refreshUsePlaceAndPoints = () => {
      setUserPlace(App.INSTANCE.CurrentUser.getLeaderboardOrdinal());
      setUserPoints(App.INSTANCE.CurrentUser.Points);
    };

    App.INSTANCE.CurrentUser.addEventListener(User.EVENT_UPDATED, refreshUsePlaceAndPoints);
    refreshUsePlaceAndPoints();

    return () => {
      App.INSTANCE.CurrentUser.removeEventListener(User.EVENT_UPDATED, refreshUsePlaceAndPoints);
    };
  }, []);

  return (
    <>
      <motion.div
        className="leaderboard_card_simple"
        onClick={e => {
          App.INSTANCE.viewLeaderboard({});
          props.onBlur();
        }}
        role="link"
        aria-label={CrowdHub_App.LANG.PROFILE_DROPDOWN_LEADERBOARD}
      >
        <div className="text">
          <div>{CrowdHub_App.LANG.PROFILE_DROPDOWN_LEADERBOARD}</div>
          <div className="sub_text">
            <i className={`points_icon_container ${FontAwesomeConfigurations.ICON_POINTSBOLT_SOLID}`}></i>
            <div className="points" role="currentpoints">
              {userPoints}
            </div>
            <div className="separator margin_left margin_right">|</div>
            <div className="place" role="currentplace">{`${userPlace} Place`}</div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default LeaderboardCardSimple;
